import onAddCrisisAllocation from './onAddCrisisAllocation';
import onEditCrisisAllocation from './onEditCrisisAllocation';
import onDeleteCrisisAllocation from './onDeleteCrisisAllocation';
import onGetCrisisCalls from './onGetCrisisCalls';
import onEditCrisisAddress from './onEditCrisisAddress';
import onGetCrisisCallTeamMembers from './onGetCrisisCallTeamMembers';
import onCrisisCallResolve from './onCrisisCallResolve';

export default {
  onAddCrisisAllocation,
  onEditCrisisAllocation,
  onDeleteCrisisAllocation,
  onGetCrisisCalls,
  onEditCrisisAddress,
  onGetCrisisCallTeamMembers,
  onCrisisCallResolve,
};
